import type { GetApiCourses200PageableSort } from './getApiCourses200PageableSort';

/**
 * Spring Data Pageable 정보
 */
export type GetApiCourses200Pageable = {
  /** 요청된 페이지 번호 */
  page?: number;
  /** 요청된 페이지 크기 */
  size?: number;
  /** Spring Data Sort 정보 */
  sort?: GetApiCourses200PageableSort;
};
